import { LDSButton, LDSDialog } from "@resmed/lumina-design-system";
import infoIcon from "../../../assets/info.svg";

export interface ActionConfirmationProps {
  visible: boolean;
  title: string;
  description?: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmSeverity?: "default" | "danger";
  warningHeader?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ActionConfirmation = ({
  visible,
  title,
  description,
  confirmLabel,
  cancelLabel = "Cancel",
  confirmSeverity = "default",
  warningHeader = false,
  onConfirm,
  onCancel,
}: ActionConfirmationProps) => {
  return (
    <LDSDialog
      id="action-confirmation-dialog"
      headerTitle={warningHeader ? undefined : title}
      header={
        warningHeader ? (
          <div className="lds-flex lds-items-center lds-gap-3">
            <img src={infoIcon} alt="" width={21} height={19} />
            <span className="lds-typography-heading-text-lg lds-text-textcolor-warning">
              {title}
            </span>
          </div>
        ) : undefined
      }
      visible={visible}
      onHide={onCancel}
      dismissableMask
      closeOnEscape
      blockScroll
      fullScreenIcon={false}
      size="medium"
      rootClassName="lds-w-[90vw] lds-max-w-2xl"
      footer={
        <div className="lds-flex lds-gap-4">
          <LDSButton
            id="action-confirmation-confirm"
            label={confirmLabel}
            severity={confirmSeverity}
            onClick={onConfirm}
          />
          <LDSButton
            id="action-confirmation-cancel"
            label={cancelLabel}
            outlined
            severity="secondary"
            onClick={onCancel}
          />
        </div>
      }
    >
      {description && (
        <p className="lds-typography-base-regular lds-text-textcolor-weak">
          {description}
        </p>
      )}
    </LDSDialog>
  );
};

export default ActionConfirmation;
